/**
 * Entries (E470, ADR-034, spec 20 section 4 "Entries"): the things a business
 * has and posts about. A business names its own types ("Standort",
 * "Leistung"); each type has one of these fixed kinds, which decides the
 * entry's `details` and rules. The database CHECKs list the same kinds.
 */
export const ENTRY_KINDS = ['person', 'apartment', 'place', 'product', 'service', 'other'];
export function isEntryKind(value) {
    return typeof value === 'string' && ENTRY_KINDS.includes(value);
}
/** Field limits of spec 20 section 4 "Entries"; API validation and the web client share them. */
export const ENTRY_LIMITS = {
    typesPerProperty: 30,
    entriesPerProperty: 1000,
    typeNameMaxLength: 60,
    rotationMinDays: 7,
    rotationMaxDays: 365,
    nameMaxLength: 120,
    summaryMaxLength: 300,
    noteMaxLength: 2000,
    /** Related entries and linked knowledge items, each. */
    maxLinks: 50,
    roleMaxLength: 120,
    maxGuests: 50,
    maxFeatures: 50,
    featureMaxLength: 80,
    streetMaxLength: 120,
    postalCodeMaxLength: 20,
    cityMaxLength: 120,
    urlMaxLength: 500,
};
/** `numeric(6,1)` as a decimal string, as apartments had it. */
export const ENTRY_SIZE_PATTERN = /^\d{1,5}(\.\d)?$/;
/** A price amount as a decimal string: money is never a float. */
export const ENTRY_PRICE_PATTERN = /^\d{1,7}(\.\d{1,2})?$/;
export const ENTRY_CURRENCY_PATTERN = /^[A-Z]{3}$/;
/** The `details` keys each kind offers (spec 20 section 4 table). */
export const ENTRY_DETAIL_KEYS = {
    person: ['role'],
    apartment: ['size_sqm', 'max_guests', 'features'],
    place: ['address'],
    product: ['price', 'url'],
    service: ['price', 'url'],
    other: [],
};
let currencies = null;
/** ISO 4217 codes as the runtime knows them (`Intl.supportedValuesOf`). */
export function isCurrencyCode(value) {
    if (typeof value !== 'string' || !ENTRY_CURRENCY_PATTERN.test(value))
        return false;
    currencies ??= new Set(Intl.supportedValuesOf('currency'));
    return currencies.has(value);
}
//# sourceMappingURL=entry-kinds.js.map